import styled from '@emotion/styled';
import { Button, Stack, Text, tokens } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import processErrorGraphic from '../../../../resources/images/processed-error.svg';
import { Image, TextWithLineBreak } from '../ProcessOrderContainer.styles';

interface Props {
  onGoBack: () => void;
  retry: () => void;
}

const S = {
  Image: styled(Image)`
    width: 38%;
  `,
  TextWithLineBreak: styled(TextWithLineBreak)`
    margin-top: ${tokens.spacer.x2};
  `,
  ButtonsContainer: styled.div`
    display: flex;
    gap: ${tokens.spacer.x2};
    justify-content: center;
    margin-top: ${tokens.spacer.x6};
  `,
};

export function ProcessOrderError({ onGoBack, retry }: Props): JSX.Element {
  const { t } = useTranslationWithPrefix('checkout:process-order.error');
  const [backToCheckout, tryAgain] = t<string, string[]>('actions', { returnObjects: true });

  return (
    <Stack spacing="x3" direction="column">
      <S.Image src={processErrorGraphic} alt="" />
      <S.TextWithLineBreak as="h1" textType="header4">
        {t('title')}
      </S.TextWithLineBreak>
      <div>
        <Text as="p" textType="body2">
          {t('body')}
        </Text>
        <S.ButtonsContainer>
          <Button as="a" kind="ghost" onClick={onGoBack}>
            {backToCheckout}
          </Button>
          <Button kind="primary" onClick={retry}>
            {tryAgain}
          </Button>
        </S.ButtonsContainer>
      </div>
    </Stack>
  );
}
